import { Directive, input } from '@angular/core';
import { WidgetInputBase } from '@trackback/widgets';

@Directive()
export abstract class WidgetInputBaseComponent<T extends WidgetInputBase> {
  input = input.required<T>();
  context = input.required<Record<string, never>>();
}
